module.exports = __webpack_public_path__ + "static/img/hou3.c5fcf53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/hou3.png
// module id = O/pz
// module chunks = 0